import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MachineList } from "../../../../../API/machines";
import classes from "./TaskmapWizard.module.css";
import React, { useEffect, useState } from "react";

export type MachineSelectorProps = {
  machines: MachineList;
  setMachine: (machine: string) => void;
};

export function MachineSelector({
  machines,
  setMachine,
}: MachineSelectorProps): React.ReactNode {
  const { t } = useTranslation();
  const defaultMachineId = machines[0]?.id ?? "";
  const [selectedMachine, setSelectedMachine] =
    useState<string>(defaultMachineId);

  useEffect(() => {
    if (defaultMachineId) {
      setMachine(defaultMachineId);
    }
  }, [defaultMachineId, setMachine]);

  return (
    <div className={classes.selector}>
      <FormControl className={classes.selector}>
        <InputLabel id="select-machine-label">{t("label.Machine")}</InputLabel>
        <Select
          labelId="select-machine-label"
          name="machine"
          value={selectedMachine}
          fullWidth={true}
          onChange={(event) => {
            const value = event.target.value as string;
            setSelectedMachine(value);
            setMachine(value);
          }}
        >
          {machines.map((machine) => (
            <MenuItem key={machine.id} value={machine.id}>
              {t(`machine.${machine.id}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
